// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/number-input"};